import { render, staticRenderFns } from "./TireRecommendationSidebar.vue?vue&type=template&id=ac6ce9e8"
import script from "./TireRecommendationSidebar.vue?vue&type=script&lang=ts"
export * from "./TireRecommendationSidebar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports